import { render, staticRenderFns } from "./MocktestsGenerate.vue?vue&type=template&id=8dd9d1ba&"
import script from "./MocktestsGenerate.vue?vue&type=script&lang=js&"
export * from "./MocktestsGenerate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports